import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { apiGetCurrentCandidatePipeline } from '../../api/api';

export interface CandidateProfile {
    star_rating: string;
    seniority: string;
    years_of_experience: number;
    job_title_category: [string];
    selling_points: [string];
}

export interface CurrentCandidatePipelineState {
    candidate_profiles: CandidateProfile[];
    status: 'idle' | 'loading' | 'success' | 'failed';
}

const initialState: CurrentCandidatePipelineState = {
    candidate_profiles: [],
    status: 'idle',
};

export const getCurrentCandidatePipelineAsync = createAsyncThunk(
  'currentCandidatePipeline/apiGetCurrentCandidatePipeline',
  async () => {
    const response = await apiGetCurrentCandidatePipeline();

    // The value we return becomes the `fulfilled` action payload
    return response;
  }
)

export const currentCandidatePipelineSlice = createSlice({
  name: 'currentCandidatePipeline',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStatus: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.status = 'idle';
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(getCurrentCandidatePipelineAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getCurrentCandidatePipelineAsync.fulfilled, (state, action) => {
        // When the status field of the server response is 400
        // there was an error with the subscription request
        if(action.payload.status != null || action.payload.status !== 422) {
            state.candidate_profiles = action.payload
            state.status = 'success';
        } else {
            state.status = 'failed';
        }
      })
      .addCase(getCurrentCandidatePipelineAsync.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const { clearStatus } = currentCandidatePipelineSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectCurrentCandidatePipelineStatus = (state: RootState) => state.currentCandidatePipeline.status;
export const selectCurrentCandidatePipelineProfiles = (state: RootState) => state.currentCandidatePipeline.candidate_profiles;

export default currentCandidatePipelineSlice.reducer;